import { Table, Tbody, Tr, Td } from '@components/core-ui/Table/Table';
import { FilePreview } from '@components/Files/FilePreview';
import { useUploadContext } from '@components/Files/UploadProvider';
import { formatDuration } from '@components/FileUpload/components/dropzone';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { BulkJobStep, useCurrentModalContext } from '../../providers/ModalProvider';

export const SubmitPriceStep = () => {
  const { step, isLoading, error, totalDuration, onSuccess, submitJobs, balanceInCents, tierRate } =
    useCurrentModalContext();
  const { files } = useUploadContext();

  const totalPrice = totalDuration ? (totalDuration / 3600) * tierRate : 0;
  const notEnoughBalance = totalPrice > balanceInCents / 100;

  if (step !== BulkJobStep.SubmitPrice) {
    return null;
  }

  return (
    <div className="step-wrapper">
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="previews">
        {files.map((item, index) => {
          return (
            <div key={index} className="file-wrapper">
              <FilePreview item={item} allowRemove={false} />
            </div>
          );
        })}
      </div>
      {files.length > 0 ? (
        <Table className="text-left text-xs border-collapse">
          <Tbody>
            <Tr className="border-b border-solid border-[var(--color-divider)]">
              <Td className="text-[var(--color-text-muted)] font-[600] py-2">Total duration</Td>
              <Td className="text-sm text-right py-2">{formatDuration(totalDuration)}</Td>
            </Tr>
            <Tr>
              <Td className="text-[var(--color-text-muted)] font-[600] py-2">Total price for bulk job</Td>
              <Td className="text-sm font-[600] text-right py-2">${totalPrice.toFixed(2)}</Td>
            </Tr>
          </Tbody>
        </Table>
      ) : null}
      {error ? <div className="errorMessage">{error}</div> : null}
      {notEnoughBalance ? <div className="errorMessage">Your balance is insufficient</div> : null}
      <div className="buttonContainer">
        <OutlinedButton onClick={onSuccess}>Cancel</OutlinedButton>
        <Button className="ml-4" onClick={submitJobs} disabled={isLoading || !files.length || notEnoughBalance}>
          Submit Jobs
        </Button>
      </div>
    </div>
  );
};
